/*! http://www.therigy.com/
 * Copyright (c) 2023 Therigy, LLC */
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import App from './App';
import ErrorFallback from './components/Common/ErrorFallback';
import * as serviceWorker from './serviceWorker';
import store from './stores/index';

ReactDOM.render(
    <React.StrictMode>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root'),
);

console.disableYellowBox = true;
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
